function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from "react";
import { getFileExtension } from "../../../../utils/docHelper";
import FiExternalLink from "@meronex/icons/fi/FiExternalLink";
import FiShare2 from "@meronex/icons/fi/FiShare2";
import FiEdit from "@meronex/icons/fi/FiEdit";
import { toast } from "react-toastify";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var getIcon = function getIcon(type) {
  switch (type) {
    case "jpeg":
    case "jpg":
    case "png":
      return renderImageIcon();
    case "docx":
    case "doc":
    case "xml":
      return renderDocxIcon();
    case "pdf":
      return renderPdfIcon();
    case "csv":
    case "xlsx":
    case "xlsm":
      return renderExcelIcon();
    default:
      return renderPdfIcon();
  }
};
var renderPdfIcon = function renderPdfIcon() {
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    children: /*#__PURE__*/_jsxs("g", {
      id: "Group_10531",
      "data-name": "Group 10531",
      transform: "translate(-1009 -689)",
      children: [/*#__PURE__*/_jsx("path", {
        id: "Path_6451",
        "data-name": "Path 6451",
        d: "M5,0H35a5,5,0,0,1,5,5V35a5,5,0,0,1-5,5H5a5,5,0,0,1-5-5V5A5,5,0,0,1,5,0Z",
        transform: "translate(1009 689)",
        fill: "#d24f3e"
      }), /*#__PURE__*/_jsx("text", {
        id: "PDF",
        transform: "translate(1029 715)",
        fill: "#fff",
        "font-size": "14",
        "font-family": "SegoeUI, Segoe UI",
        children: /*#__PURE__*/_jsx("tspan", {
          x: "-12.247",
          y: "0",
          children: "PDF"
        })
      })]
    })
  });
};
var renderDocxIcon = function renderDocxIcon() {
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    children: /*#__PURE__*/_jsxs("g", {
      id: "Group_10531",
      "data-name": "Group 10531",
      transform: "translate(-1009 -689)",
      children: [/*#__PURE__*/_jsx("g", {
        id: "Component_1_1",
        "data-name": "Component 1 \u2013 1",
        transform: "translate(1009 689)",
        children: /*#__PURE__*/_jsx("path", {
          id: "Path_6451",
          "data-name": "Path 6451",
          d: "M5,0H35a5,5,0,0,1,5,5V35a5,5,0,0,1-5,5H5a5,5,0,0,1-5-5V5A5,5,0,0,1,5,0Z",
          fill: "#4d78eb"
        })
      }), /*#__PURE__*/_jsx("text", {
        id: "DOC",
        transform: "translate(1029 715)",
        fill: "#fff",
        "font-size": "14",
        "font-family": "SegoeUI, Segoe UI",
        children: /*#__PURE__*/_jsx("tspan", {
          x: "-14.52",
          y: "0",
          children: "DOC"
        })
      })]
    })
  });
};
var renderExcelIcon = function renderExcelIcon() {
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    children: /*#__PURE__*/_jsxs("g", {
      id: "Group_10531",
      "data-name": "Group 10531",
      transform: "translate(-1009 -689)",
      children: [/*#__PURE__*/_jsx("g", {
        id: "Component_1_1",
        "data-name": "Component 1 \u2013 1",
        transform: "translate(1009 689)",
        children: /*#__PURE__*/_jsx("path", {
          id: "Path_6451",
          "data-name": "Path 6451",
          d: "M5,0H35a5,5,0,0,1,5,5V35a5,5,0,0,1-5,5H5a5,5,0,0,1-5-5V5A5,5,0,0,1,5,0Z",
          fill: "#14897b"
        })
      }), /*#__PURE__*/_jsx("text", {
        id: "XLS",
        transform: "translate(1029 715)",
        fill: "#fff",
        "font-size": "14",
        "font-family": "SegoeUI, Segoe UI",
        children: /*#__PURE__*/_jsx("tspan", {
          x: "-11.143",
          y: "0",
          children: "XLS"
        })
      })]
    })
  });
};
var renderImageIcon = function renderImageIcon() {
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    children: /*#__PURE__*/_jsxs("g", {
      id: "Group_10531",
      "data-name": "Group 10531",
      transform: "translate(-1009 -689)",
      children: [/*#__PURE__*/_jsx("g", {
        id: "Component_1_1",
        "data-name": "Component 1 \u2013 1",
        transform: "translate(1009 689)",
        children: /*#__PURE__*/_jsx("path", {
          id: "Path_6451",
          "data-name": "Path 6451",
          d: "M5,0H35a5,5,0,0,1,5,5V35a5,5,0,0,1-5,5H5a5,5,0,0,1-5-5V5A5,5,0,0,1,5,0Z",
          fill: "#4652a4"
        })
      }), /*#__PURE__*/_jsx("text", {
        id: "JPG",
        transform: "translate(1029 715)",
        fill: "#fff",
        "font-size": "14",
        "font-family": "SegoeUI, Segoe UI",
        children: /*#__PURE__*/_jsx("tspan", {
          x: "-11.221",
          y: "0",
          children: "JPG"
        })
      })]
    })
  });
};
function ProjectBrochures(_ref) {
  var brochure = _ref.brochure,
    config = _ref.config,
    appType = _ref.appType,
    winnreAuth = _ref.winnreAuth;
  console.log("brochures:", brochure);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    loadingShareId = _useState2[0],
    setLoadingShareId = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    errorShareId = _useState4[0],
    setErrorShareId = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showShareModal = _useState6[0],
    setShowShareModal = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedBrochureForShare = _useState8[0],
    setSelectedBrochureForShare = _useState8[1];
  var _useState9 = useState({
      email: "",
      phone: "",
      website: ""
    }),
    _useState0 = _slicedToArray(_useState9, 2),
    shareFormData = _useState0[0],
    setShareFormData = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    shareSuccess = _useState10[0],
    setShareSuccess = _useState10[1];
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    shareError = _useState12[0],
    setShareError = _useState12[1];
  var isImage = ["jpeg", "jpg", "png"];
  var isPdf = "pdf";
  var isText = ["txt", "doc", "docx"];
  var displayType = function displayType(src) {
    // console.log(`Displaying brochure type for: ${src}`);
    var fileType = getFileExtension(src);
    if (isImage.includes(fileType)) {
      return /*#__PURE__*/_jsx("img", {
        className: "h-[200px] rounded-xl",
        src: src,
        alt: "Brochure"
      });
    } else {
      return /*#__PURE__*/_jsx("iframe", {
        src: "".concat(src, "#view=FitV&page=1&scrollbar=0&toolbar=0&statusbar=0&messages=0&navpanes=0"),
        width: "100%",
        height: "100%",
        title: "PDF Preview"
      });
    }
  };
  var handleView = function handleView(url, collateralTemplate) {
    if (collateralTemplate === null) {
      window.open(url);
    } else {
      window.open(url, "_blank");
    }
  };
  var handleShare = function handleShare(brochureId, url, customizable) {
    if (!customizable) {
      // For non-customizable brochures, directly open the file
      window.open(url, "_blank");
      return;
    }

    // For customizable brochures, open modal to collect details
    setSelectedBrochureForShare({
      id: brochureId,
      url: url,
      customizable: customizable
    });
    setShowShareModal(true);
    setShareFormData({
      email: "",
      phone: "",
      website: ""
    });
    setShareSuccess(false);
    setShareError(null);
  };
  var handleFormChange = function handleFormChange(field, value) {
    setShareFormData(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, field, value));
    });
  };
  var handleSubmitShare = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var emailRegex, phoneRegex, response, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            // Validate form
            emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            phoneRegex = /^\d{10}$/;
            if (shareFormData.email) {
              _context.n = 1;
              break;
            }
            setShareError("Email is mandatory");
            return _context.a(2);
          case 1:
            if (emailRegex.test(shareFormData.email)) {
              _context.n = 2;
              break;
            }
            setShareError("Please enter a valid email");
            return _context.a(2);
          case 2:
            if (shareFormData.phone) {
              _context.n = 3;
              break;
            }
            setShareError("Phone is mandatory");
            return _context.a(2);
          case 3:
            if (phoneRegex.test(shareFormData.phone)) {
              _context.n = 4;
              break;
            }
            setShareError("Phone must be 10 digits");
            return _context.a(2);
          case 4:
            setLoadingShareId(selectedBrochureForShare.id);
            setShareError(null);
            _context.p = 5;
            if (!selectedBrochureForShare.customizable) {
              _context.n = 7;
              break;
            }
            _context.n = 6;
            return winnreAuth.post("/winnre/user/collateral/custom-brochure-v3", {
              projectBrochureId: selectedBrochureForShare.id,
              email: shareFormData.email,
              mobileNumber: shareFormData.phone,
              whatsapp: shareFormData.phone,
              website: shareFormData.website || undefined
            });
          case 6:
            response = _context.v;
            if (response.status === "FAILED") {
              setShareError("Failed to generate custom brochure");
              toast.error("Failed to generate custom brochure");
            } else {
              setShareSuccess(true);
              toast.success("Custom brochure generated successfully");
            }
            _context.n = 8;
            break;
          case 7:
            // For non-customizable, just show success and open URL
            window.open(selectedBrochureForShare.url, "_blank");
            setShareSuccess(true);
            toast.success("Opening brochure...");
          case 8:
            _context.n = 10;
            break;
          case 9:
            _context.p = 9;
            _t = _context.v;
            console.error("Error sharing brochure:", _t);
            setShareError("Error generating custom brochure");
            toast.error("Error generating custom brochure");
          case 10:
            _context.p = 10;
            setLoadingShareId(null);
            return _context.f(10);
          case 11:
            return _context.a(2);
        }
      }, _callee, null, [[5, 9, 10, 11]]);
    }));
    return function handleSubmitShare() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleCloseModal = function handleCloseModal() {
    setShowShareModal(false);
    setSelectedBrochureForShare(null);
    setShareFormData({
      email: "",
      phone: "",
      website: ""
    });
    setShareSuccess(false);
    setShareError(null);
  };
  var title = appType === "winnre" ? "Sales Kit" : "Brochures";

  // Only group brochures if appType is winnre
  var content;
  if (appType === "winnre") {
    // Group brochures by collateralTemplate heading for winnre
    var groupedBrochures = (brochure === null || brochure === void 0 ? void 0 : brochure.reduce(function (acc, broc) {
      var heading = (broc === null || broc === void 0 ? void 0 : broc.heading) || "Other";
      if (!acc[heading]) {
        acc[heading] = [];
      }
      acc[heading].push(broc);
      return acc;
    }, {})) || {};
    content = Object.entries(groupedBrochures).map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        heading = _ref4[0],
        brochures = _ref4[1];
      return /*#__PURE__*/_jsxs("div", {
        className: "mb-8",
        children: [heading !== "Other" && /*#__PURE__*/_jsx("h5", {
          className: "z-10 text-lg ".concat(config !== null && config !== void 0 && config.darkMode ? "text-base-content" : "text-[#130E2F]", " my-3 font-semibold ").concat(config.fontBody),
          children: heading
        }), /*#__PURE__*/_jsx("div", {
          className: "grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5",
          children: brochures === null || brochures === void 0 ? void 0 : brochures.map(function (broc) {
            return /*#__PURE__*/_jsxs("div", {
              className: " ".concat(config.fontBody, " z-10 bg-gray-200 p-4 rounded-xl border-white border-2 hover:border-primary flex flex-col"),
              children: [/*#__PURE__*/_jsxs("div", {
                className: "flex items-center mb-2 justify-between",
                children: [/*#__PURE__*/_jsxs("div", {
                  className: "flex items-center",
                  children: [getIcon(getFileExtension(broc !== null && broc !== void 0 && broc.url ? broc === null || broc === void 0 ? void 0 : broc.url : broc === null || broc === void 0 ? void 0 : broc.name)), /*#__PURE__*/_jsx("h1", {
                    className: "font-semibold ml-2 xl:text-[15px] 2xl:text-[16px]",
                    children: broc === null || broc === void 0 ? void 0 : broc.name
                  })]
                }), (broc === null || broc === void 0 ? void 0 : broc.customizable) && /*#__PURE__*/_jsx("div", {
                  className: "ml-2 p-1 rounded-full bg-blue-100",
                  children: /*#__PURE__*/_jsx(FiEdit, {
                    size: 16,
                    className: "text-blue-600"
                  })
                })]
              }), /*#__PURE__*/_jsx("div", {
                className: "flex-grow",
                children: displayType(broc !== null && broc !== void 0 && broc.url ? broc === null || broc === void 0 ? void 0 : broc.url : broc === null || broc === void 0 ? void 0 : broc.name)
              }), /*#__PURE__*/_jsxs("div", {
                className: "flex gap-3 mt-4",
                children: [/*#__PURE__*/_jsxs("button", {
                  onClick: function onClick() {
                    return handleView(broc === null || broc === void 0 ? void 0 : broc.url, broc === null || broc === void 0 ? void 0 : broc.collateralTemplate);
                  },
                  className: "flex items-center justify-center gap-2 flex-1 px-3 py-2 rounded-lg font-semibold text-sm transition-colors ".concat(config !== null && config !== void 0 && config.darkMode ? "bg-primary text-white hover:bg-opacity-90" : "bg-primary text-white hover:bg-opacity-90"),
                  children: [/*#__PURE__*/_jsx(FiExternalLink, {
                    size: 16
                  }), "View"]
                }), /*#__PURE__*/_jsx("button", {
                  onClick: function onClick() {
                    return handleShare(broc === null || broc === void 0 ? void 0 : broc.id, broc === null || broc === void 0 ? void 0 : broc.url, broc === null || broc === void 0 ? void 0 : broc.customizable);
                  },
                  disabled: loadingShareId === (broc === null || broc === void 0 ? void 0 : broc.id),
                  className: "flex items-center justify-center gap-2 flex-1 px-3 py-2 rounded-lg font-semibold text-sm transition-colors ".concat(loadingShareId === (broc === null || broc === void 0 ? void 0 : broc.id) ? "opacity-50 cursor-not-allowed" : "", " ").concat(config !== null && config !== void 0 && config.darkMode ? "bg-gray-600 text-white hover:bg-gray-700" : "bg-gray-400 text-white hover:bg-gray-500"),
                  children: loadingShareId === (broc === null || broc === void 0 ? void 0 : broc.id) ? /*#__PURE__*/_jsxs(_Fragment, {
                    children: [/*#__PURE__*/_jsx("span", {
                      className: "animate-spin",
                      children: "\u27F3"
                    }), "Loading"]
                  }) : /*#__PURE__*/_jsxs(_Fragment, {
                    children: [/*#__PURE__*/_jsx(FiShare2, {
                      size: 16
                    }), "Share"]
                  })
                })]
              }), errorShareId === (broc === null || broc === void 0 ? void 0 : broc.id) && /*#__PURE__*/_jsx("div", {
                className: "mt-2 p-2 rounded text-sm ".concat(config !== null && config !== void 0 && config.darkMode ? "bg-red-900 text-red-200" : "bg-red-100 text-red-700"),
                children: "Error generating brochure"
              })]
            }, broc === null || broc === void 0 ? void 0 : broc.id);
          })
        })]
      }, heading);
    });
  } else {
    // Simple list for non-winnre apps without buttons
    content = /*#__PURE__*/_jsx("div", {
      className: "grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5",
      children: brochure === null || brochure === void 0 ? void 0 : brochure.map(function (broc) {
        return /*#__PURE__*/_jsxs("div", {
          onClick: function onClick() {
            window.open(broc === null || broc === void 0 ? void 0 : broc.url);
          },
          className: " ".concat(config.fontBody, " z-10 bg-gray-200 p-4 rounded-xl cursor-pointer border-white border-2 hover:border-primary"),
          children: [/*#__PURE__*/_jsxs("div", {
            className: "flex items-center mb-2",
            children: [getIcon(getFileExtension(broc !== null && broc !== void 0 && broc.url ? broc === null || broc === void 0 ? void 0 : broc.url : broc === null || broc === void 0 ? void 0 : broc.name)), /*#__PURE__*/_jsx("h1", {
              className: "font-semibold ml-2 xl:text-[15px] 2xl:text-[16px]",
              children: broc === null || broc === void 0 ? void 0 : broc.name
            })]
          }), /*#__PURE__*/_jsx("div", {
            children: displayType(broc !== null && broc !== void 0 && broc.url ? broc === null || broc === void 0 ? void 0 : broc.url : broc === null || broc === void 0 ? void 0 : broc.name)
          })]
        }, broc === null || broc === void 0 ? void 0 : broc.id);
      })
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    className: "mt-8 flex flex-col",
    children: [/*#__PURE__*/_jsx("h4", {
      className: "z-10 text-xl ".concat(config !== null && config !== void 0 && config.darkMode ? "text-primary" : "text-[#130E2F]", " my-2 font-bold ").concat(config.fontTitle),
      children: title
    }), content, showShareModal && /*#__PURE__*/_jsx("div", {
      className: "fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50",
      children: /*#__PURE__*/_jsx("div", {
        className: "w-full max-w-md mx-4 rounded-lg p-6 ".concat(config !== null && config !== void 0 && config.darkMode ? "bg-gray-800" : "bg-white"),
        children: shareSuccess ? /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsxs("div", {
            className: "text-center mb-6",
            children: [/*#__PURE__*/_jsx("div", {
              className: "w-16 h-16 mx-auto mb-4 rounded-full bg-green-100 flex items-center justify-center",
              children: /*#__PURE__*/_jsx("svg", {
                className: "w-8 h-8 text-green-600",
                fill: "currentColor",
                viewBox: "0 0 20 20",
                children: /*#__PURE__*/_jsx("path", {
                  fillRule: "evenodd",
                  d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
                  clipRule: "evenodd"
                })
              })
            }), /*#__PURE__*/_jsx("h3", {
              className: "text-lg font-semibold mb-2 ".concat(config !== null && config !== void 0 && config.darkMode ? "text-white" : "text-gray-900"),
              children: "Brochure Sent Successfully!"
            }), /*#__PURE__*/_jsx("p", {
              className: "text-sm ".concat(config !== null && config !== void 0 && config.darkMode ? "text-gray-400" : "text-gray-600"),
              children: "Your custom brochure has been generated and will be sent to your provided contact details."
            })]
          }), /*#__PURE__*/_jsx("button", {
            onClick: handleCloseModal,
            className: "w-full px-4 py-2 bg-primary text-white rounded-lg font-semibold hover:bg-opacity-90",
            children: "Close"
          })]
        }) : /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("h3", {
            className: "text-lg font-semibold mb-4 ".concat(config !== null && config !== void 0 && config.darkMode ? "text-white" : "text-gray-900"),
            children: "Share Brochure"
          }), shareError && /*#__PURE__*/_jsx("div", {
            className: "mb-4 p-3 rounded text-sm ".concat(config !== null && config !== void 0 && config.darkMode ? "bg-red-900 text-red-200" : "bg-red-100 text-red-700"),
            children: shareError
          }), /*#__PURE__*/_jsxs("div", {
            className: "space-y-4 mb-6",
            children: [/*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsxs("label", {
                className: "block text-sm font-semibold mb-2 ".concat(config !== null && config !== void 0 && config.darkMode ? "text-gray-300" : "text-gray-700"),
                children: ["Email ", /*#__PURE__*/_jsx("span", {
                  className: "text-red-500",
                  children: "*"
                })]
              }), /*#__PURE__*/_jsx("input", {
                type: "email",
                value: shareFormData.email,
                onChange: function onChange(e) {
                  return handleFormChange("email", e.target.value);
                },
                placeholder: "your@email.com",
                className: "w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary ".concat(config !== null && config !== void 0 && config.darkMode ? "bg-gray-700 border-gray-600 text-white placeholder-gray-400" : "bg-white border-gray-300 text-gray-900")
              })]
            }), /*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsxs("label", {
                className: "block text-sm font-semibold mb-2 ".concat(config !== null && config !== void 0 && config.darkMode ? "text-gray-300" : "text-gray-700"),
                children: ["Phone (10 digits) ", /*#__PURE__*/_jsx("span", {
                  className: "text-red-500",
                  children: "*"
                })]
              }), /*#__PURE__*/_jsx("input", {
                type: "tel",
                inputMode: "numeric",
                maxLength: "10",
                value: shareFormData.phone,
                onChange: function onChange(e) {
                  return handleFormChange("phone", e.target.value.replace(/\D/g, ""));
                },
                placeholder: "9876543210",
                className: "w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary ".concat(config !== null && config !== void 0 && config.darkMode ? "bg-gray-700 border-gray-600 text-white placeholder-gray-400" : "bg-white border-gray-300 text-gray-900")
              })]
            }), /*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsx("label", {
                className: "block text-sm font-semibold mb-2 ".concat(config !== null && config !== void 0 && config.darkMode ? "text-gray-300" : "text-gray-700"),
                children: "Website"
              }), /*#__PURE__*/_jsx("input", {
                type: "url",
                value: shareFormData.website,
                onChange: function onChange(e) {
                  return handleFormChange("website", e.target.value);
                },
                placeholder: "https://example.com",
                className: "w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary ".concat(config !== null && config !== void 0 && config.darkMode ? "bg-gray-700 border-gray-600 text-white placeholder-gray-400" : "bg-white border-gray-300 text-gray-900")
              })]
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "flex gap-3",
            children: [/*#__PURE__*/_jsx("button", {
              onClick: handleCloseModal,
              disabled: loadingShareId === (selectedBrochureForShare === null || selectedBrochureForShare === void 0 ? void 0 : selectedBrochureForShare.id),
              className: "flex-1 px-4 py-2 border rounded-lg font-semibold transition-colors ".concat(config !== null && config !== void 0 && config.darkMode ? "border-gray-600 text-gray-300 hover:bg-gray-700" : "border-gray-300 text-gray-700 hover:bg-gray-50"),
              children: "Cancel"
            }), /*#__PURE__*/_jsx("button", {
              onClick: handleSubmitShare,
              disabled: loadingShareId === (selectedBrochureForShare === null || selectedBrochureForShare === void 0 ? void 0 : selectedBrochureForShare.id),
              className: "flex-1 px-4 py-2 bg-primary text-white rounded-lg font-semibold hover:bg-opacity-90 flex items-center justify-center gap-2 ".concat(loadingShareId === (selectedBrochureForShare === null || selectedBrochureForShare === void 0 ? void 0 : selectedBrochureForShare.id) ? "opacity-50 cursor-not-allowed" : ""),
              children: loadingShareId === (selectedBrochureForShare === null || selectedBrochureForShare === void 0 ? void 0 : selectedBrochureForShare.id) ? /*#__PURE__*/_jsxs(_Fragment, {
                children: [/*#__PURE__*/_jsx("span", {
                  className: "animate-spin",
                  children: "\u27F3"
                }), "Sending..."]
              }) : "Send Brochure"
            })]
          })]
        })
      })
    })]
  });
}
export default ProjectBrochures;